import React, { useState } from "react";
import "./ModifyUsers.css";
import { FormattedMessage } from "react-intl";
import useSelectUser from "../../../common/SelectUser/SelectUser.hooks";

const ModifyUsers = ({
  selectedPlan,
  onUserSelect,
  minSeats,
  setNbLicenses,
}) => {
  const [usersToggle, setUsersToggle] = useState(false);

  const { usersAndCredits, defaultUsersAndCredits } = useSelectUser({
    planId: selectedPlan.planId,
    minSeats,
  });

  const handleIncrement = () => {
    const newNumberOfSeats = selectedPlan.numberOfSeats + 1;
    setNbLicenses(newNumberOfSeats);
    onUserSelect(newNumberOfSeats, selectedPlan);
  };

  const handleDecrement = () => {
    if (selectedPlan.numberOfSeats > 1) {
      const newNumberOfSeats = selectedPlan.numberOfSeats - 1;
      setNbLicenses(newNumberOfSeats);
      onUserSelect(newNumberOfSeats, selectedPlan);
    }
  };

  return (
    <div id="modify-users">
      <div className="modify-left-ctn">
        <img src="/assets/images/modify-users.svg" />
        <div>
          <h2>
            <FormattedMessage id="organizations.addLicences" />
          </h2>
          <h3>
            <FormattedMessage id="billing.customizePlan.selectTotalNbOfLicenses" />
          </h3>
        </div>
      </div>
      <div className="plan-ctn">
        <div className="decrement-button" onClick={handleDecrement}>
          <div className="minus-stick"></div>
        </div>
        <span className="number-of-seats">{selectedPlan.numberOfSeats}</span>
        <div className="increment-button" onClick={handleIncrement}>
          <div className="plus-stick"></div>
          <div className="plus-stick vertical"></div>
        </div>
      </div>
    </div>
  );
};

export default ModifyUsers;
